import React, { useState, useEffect, useRef } from "react";
import { HiX, HiChevronDown } from "react-icons/hi";

const CustomDropdown = ({
  options,
  value,
  onChange,
  placeholder,
  width = "230px",
  height = "35px",
}) => {
  const [filterText, setFilterText] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(filterText.toLowerCase())
  );

  const handleClearFilter = (e) => {
    e.preventDefault();
    setFilterText("");
    onChange("all");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="relative" style={{ width }} ref={dropdownRef}>
      <div
        className="border border-gray-300 rounded-md p-2 cursor-pointer bg-white dark:bg-transparent dark:border-white/30 flex items-center justify-between"
        style={{ height }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span
          className={`${
            value === "all" || !value
              ? "text-gray-400"
              : "text-black dark:text-white"
          }`}
        >
          {options.find((opt) => opt.value === value)?.label || placeholder}
        </span>
        <HiChevronDown className="text-gray-500 w-5 h-5" />
      </div>
      {isOpen && (
        <div className="absolute z-10 bg-white dark:bg-gray-800 border border-gray-300 rounded-md mt-1 w-full max-h-[400px] overflow-auto">
          <div className="p-2 relative">
            <input
              type="text"
              className="w-full p-2 pr-8 border border-gray-300 rounded-md dark:bg-gray-700 dark:text-white"
              placeholder="Search..."
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
            <button
              className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500 hover:text-red-500"
              onClick={(e) => handleClearFilter(e)}
            >
              <HiX className="mr-1 w-5 h-5" />
            </button>
          </div>
          <ul className="mt-2">
            {filteredOptions.map((option) => (
              <li
                key={option.value}
                className="p-2 hover:bg-[#6366F1] dark:hover:bg-gray-700 cursor-pointer text-black hover:text-white dark:text-white"
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                }}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
